import {useOfficesAtmsTerminalsStore} from '@/stores/offices-atms-terminals';

export function useOfficeRemoteEntry() {
    const {setRemoteRecordingOffice} = useOfficesAtmsTerminalsStore();

    function isRemoteOfficeAvailable(officeInfo) {
        return officeInfo.service_cards || officeInfo.service_deposit;
    }

    function onConfirmRemoteOfficeRecording(officeInfo) {
        setRemoteRecordingOffice(officeInfo);
    }

    return {
        isRemoteOfficeAvailable,
        onConfirmRemoteOfficeRecording,
    };
};
